export default __webpack_public_path__ + "static/media/horizontal-card.60d9a749.svg";